import { useEffect, useState } from "react";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import { openModal } from "../../redux/modal/modalSlice";
import { getTaxonomyDescriptions } from "../../redux/taxonomyDescriptions/thunks";
import { getUsers } from "../../redux/users/thunks";
import { createMailMapper, deleteMailMapper, getMailMappersPag, updateMailMapper } from "../../redux/mailMappers/thunks";
import { selectMailMappers, selectMailMappersLoading } from "../../redux/mailMappers/selectors";
import { getEntryChannels } from "../../redux/entryChannels/thunks";
import { getCaseStates } from "../../redux/caseStates/thunks";
import { selectCaseStates, selectCaseStatesLoading } from "../../redux/caseStates/selectors";
import { selectUsers, selectUsersLoading } from "../../redux/users/selectors";
import { selectEntryChannels, selectEntryChannelsLoading } from "../../redux/entryChannels/selectors";
import { selectTaxonomyDescriptions, selectTaxonomyDescriptionsLoading } from "../../redux/taxonomyDescriptions/selectors";
import { selectUserLoading } from "../../redux/authentication/selectors";
import { renderCaseStateColumn } from "../../Constantes/constantesColumnasTablas";
import { useTranslation } from "react-i18next";

const initialSortOptions = {
    columna: "id",
    sortOrderAsc: false

}

function MailMapperManager() {
    const { t } = useTranslation();
    const mailMappers = useSelector(selectMailMappers);
    const dispatch = useDispatch();
    const [sortOptions, setSortOptions] = useState(initialSortOptions)
    const caseStates = useSelector(selectCaseStates)
    const users = useSelector(selectUsers)
    const entryChannels = useSelector(selectEntryChannels)
    const taxonomyDescriptions = useSelector(selectTaxonomyDescriptions)
    const loadingMappers = useSelector(selectMailMappersLoading);
    const loadingTaxonomies = useSelector(selectTaxonomyDescriptionsLoading);
    const loadingStates = useSelector(selectCaseStatesLoading);
    const loadingUsers = useSelector(selectUsersLoading)
    const loadingEntryChannels = useSelector(selectEntryChannelsLoading)

    const loading = [loadingEntryChannels, loadingMappers, loadingStates, loadingUsers, loadingTaxonomies].some(l=> l !== "succeeded") ? "loading" : "succeeded"
    
    useEffect(()=>{
        getListMailMappers(mapPageInfo(mailMappers));
        dispatch(getTaxonomyDescriptions())
        dispatch(getUsers())
        dispatch(getEntryChannels())
        dispatch(getCaseStates())
    }, [])

    function mapPageInfo(mailMapper){
        return {
            pageIndex: mailMapper.pageIndex ?? 0,
            pageSize: mailMapper.pageSize ?? 10,
            orderByField: mailMapper.columna ?? "id",
            orderByAscending: mailMapper.sortOrderAsc ?? true
        }
    }
    
    const getListMailMappers = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getMailMappersPag({query}));
    }

    const columnsMailSubjectMap = [
        <Column dataType={"string"} sortIndex={1} key={"mailmapper-1"} dataField="subject" width={"30%"} caption={t("Subject")}/>, 
        <Column dataType={"taxonomy"} cssClass={"campaign-column"} dataField={"taxonomy"} key={"mailmapper-2"} cellRender={({value})=>renderTaxonomyCell([value])} caption={t("Taxonomy")}/>,
        <Column key={"mailmapper-3"} lookup={{allowClearing: false, dataSource: entryChannels, displayExpr:'description', valueExpr: 'entryChannelId'}} width={200} dataField="entryChannelId" caption={t("EntryChannel")}/>, 
        <Column key={"mailmapper-4"} cellRender={(data)=>renderCaseStateColumn(data.value, data.text)} lookup={{allowClearing: false, dataSource: caseStates, displayExpr:'description', valueExpr: 'stateId'}} width={150} dataField="caseStateId" caption={t("State")}/>,
        <Column key={"mailmapper-5"} width={90} lookup={{allowClearing: false, dataSource: users, displayExpr:'userName', valueExpr: 'userId'}} dataField="userId" caption={t("User")}/>,
        <Column dataType={"string"} key={"mailmapper-6"} dataField="origin" width={200} caption="Origem"/>,
        <Column dataType={"boolean"} key={"mailmapper-7"} dataField="checkPlate" width={150} caption="Validar cliente"/>
    ] 
  
    function renderTaxonomyCell(rowTaxonomies){
        const toDescriptions= rowTaxonomies.map(rt=> transformToTaxonomyDescriptions(rt))
        
        return(
            <div style={{display: "flex", flexDirection: "column", rowGap: "0.25rem"}}>
                {toDescriptions.map(d=><div key={d}>{d}</div>)}
            </div>
        )
    }

    function transformToTaxonomyDescriptions(taxonomy){
        const descriptionArray = [];

        if(taxonomy.level_1)
            descriptionArray.push(taxonomyDescriptions.find(td=> td.key === taxonomy.level_1).value);
        if(taxonomy.level_2)
            descriptionArray.push(taxonomyDescriptions.find(td=> td.key === taxonomy.level_2).value)
        if(taxonomy.level_3)
            descriptionArray.push(taxonomyDescriptions.find(td=> td.key === taxonomy.level_3).value)
        if(taxonomy.level_4)
            descriptionArray.push(taxonomyDescriptions.find(td=> td.key === taxonomy.level_4).value)
        
        return  descriptionArray.join(", ")
    }


    function handleEditClick(value, closeEditModal){

        if(!validateMapperData(value))
            return;
        
        const taxonomyValue = {
            taxonomyLevel_1 : value.taxonomy?.level_1,
            taxonomyLevel_2 : value.taxonomy?.level_2,
            taxonomyLevel_3 : value.taxonomy?.level_3,
            taxonomyLevel_4 : value.taxonomy?.level_4
        }

        const mapperParams = {...value, taxonomy: taxonomyValue}

        dispatch(updateMailMapper({body: mapperParams, param: value.id})).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListMailMappers(mapPageInfo({...mailMappers, ...sortOptions}));
                        closeEditModal()
                    }    
                })      
        }

    function handleSaveClick(value, closeCreateModal) {   

            if(!validateMapperData(value))
                return;

            const taxonomyValue = {
                taxonomyLevel_1 : value.taxonomy?.level_1,
                taxonomyLevel_2 : value.taxonomy?.level_2,
                taxonomyLevel_3 : value.taxonomy?.level_3,
                taxonomyLevel_4 : value.taxonomy?.level_4
            }
            const mapperParams ={
                        body: {...value, taxonomy: taxonomyValue}
            
                    }
            dispatch(createMailMapper(mapperParams)).then((data) => {
                        if(data.error)
                            dispatch(openModal({ type: "warning", message:data.error.message}))
                        else{
                            getListMailMappers(mapPageInfo({...mailMappers, ...sortOptions}));
                            closeCreateModal();
                        }                    
                    })
        }    
    
    function handleDeleteClick(id, closeEditModal){
        dispatch(deleteMailMapper({param: id})).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                let updatedPageIndex = mailMappers.pageIndex;

                if (mailMappers.elements.length === 1) {
                    updatedPageIndex = Math.max(0, mailMappers.pageIndex - 1);
                }

                const updatedMappers = {
                    ...mailMappers,
                    pageIndex: updatedPageIndex,
                };

                getListMailMappers(mapPageInfo({...updatedMappers, ...sortOptions}));
                closeEditModal();               
            }
        })  
    }

    function validateMapperData(submitData){
        if(!submitData.subject || submitData.subject.trim() === "" )
        {
            dispatch(openModal({type: "warning", message: "El campo Asunto es obligatorio"}))
            return false
        }

        if(!submitData.entryChannelId)
        {
            dispatch(openModal({type: "warning", message: "El campo Canal de Entrada es obligatorio"}))
            return false
        }

        if(!submitData.userId)
        {
            dispatch(openModal({type: "warning", message: "El campo Usuario es obligatorio"}))
            return false
        }

        if(!submitData.caseStateId)
        {
            dispatch(openModal({type: "warning", message: "El campo Estado es obligatorio"}))
            return false
        }

        if(!submitData.origin || submitData.origin.trim() === "")
        {
            dispatch(openModal({type: "warning", message: "El campo Oigem es obligatorio"}))
            return false
        }
        return true;
    }

    return(
        <div style={{width: "100%"}}>
            <AdminTable 
                sectionTitle={t("IncomingEmails")}
                masterTitle={t("IncomingEmails")}
                itemIdField={"id"} 
                itemDescriptionField={"subject"} 
                loading={loading} 
                getData={getListMailMappers} 
                dataSource={loading !== "succeeded" ? [] : mailMappers} 
                columnasTabla={columnsMailSubjectMap} 
                onEdit={handleEditClick}
                onCreate={handleSaveClick}
                onDelete={handleDeleteClick}
                sortField={sortOptions}
                dialogSize={{height: "100%", width: "fit-content"}}
                setsortField={setSortOptions}
                numElements={[10, 25, 50]}
            />
        </div>
    )
}
export default MailMapperManager;